import type {
  GenerateShadesHexType,
  GenerateShadesParamsType,
  GenerateShadesReturnType,
  GenerateShadesStringOpts,
  NonEmptyRecord,
} from "@common/types/commonTypes/generateShades";
import { isMobile, ImportBundle } from "./utils";

/*! 公共 Start */
/**
 * 头部搜索下拉
 * @function initSearch
 * @param {string} search ".header-search_box"
 * @param {string} trigger ".search-trigger"
 **/
export function initSearch(search = ".header-search_box", trigger = ".search-trigger") {
  const searchBox = $(`.pc-header ${search}`);
  if (!searchBox.length || !trigger) return;
  $(`.pc-header ${trigger}`).on("click", (event) => {
    searchBox.slideToggle(500);
    $(document).one("click", () => {
      searchBox.slideUp(500);
    });
    event.stopPropagation();
  });
  searchBox.on("click", (event) => {
    event.stopPropagation();
  });
}

/**
 * 全局搜索方法
 * @function globalSearch
 * 公共初始化所有"form.searchForm"类的的表单，注册submit事件
 *
 **/
export function globalSearch() {
  $("form.searchForm").on("submit", (event) => {
    const form = event.target;
    const module = (form.querySelector("[name=module]")! as HTMLInputElement).value;
    const keyword = (form.querySelector("[name=keyword]")! as HTMLInputElement).value;
    if (!keyword || keyword === "") {
      alert("Please enter your search");
      return false;
    }
    window.location.href = `/search/${module}/${keyword}.html`;
  });
}

/**
 * 头部导航栏Fixed
 * @function fixedsHeader
 * @param {string} id
 * @param {string} className "header-fixeds_1"
 * @param {number} H
 **/
export function fixedsHeader(id: string, className = "header-fixeds_1", H?: number) {
  const header = $(`header.${id}`)!;
  const h = header.height()!;
  if (isMobile(1024)) {
    bindMobileHeader(header);
  } else {
    $(window).on("scroll", () => {
      if ($(window).scrollTop()! > (H ?? h)) {
        header.addClass(className + " " + "isFixed");
      } else if ($(window).scrollTop()! === 0) {
        header.removeClass(className + " " + "isFixed");
      }
    });
  }
}

export function bindMobileHeader(header: JQuery<HTMLElement>) {
  header.find(".trigger").on("click", function () {
    $(this).toggleClass("trigger_active");
    $(this).siblings(".content_mt_ul").slideToggle(300);
  });
  header.find(".mobile_nav .nav_bg").on("click", function () {
    $("html").css("overflow-y", "unset");
    $(".mobile_nav .mobile_nav_content").removeClass("nav_show");
  });
  header.find(".mobile_nav .cus-bars").on("click", function () {
    $("html").css("overflow-y", "hidden");
    $(".mobile_nav .mobile_nav_content").addClass("nav_show");
  });
}

/**
 * 懒加载 并 初始化FancyBox
 * @function initFancyBox
 **/
export function initFancyBox() {
  ImportBundle({ type: "css", isIndex: true }, ["https://static.yigetechcms.com/public/css/fancybox@5.0.0.min.css"]);
  ImportBundle({ type: "js", isIndex: true }, [
    {
      src: "https://static.yigetechcms.com/public/js/fancybox@5.0.0.min.js",
      fn: () => {
        if (window && window.Fancybox) {
          window.Fancybox.bind("[data-fancybox]", {
            Thumbs: {
              type: "classic",
            },
            Toolbar: {
              display: {
                left: ["infobar"],
                middle: ["zoomIn", "zoomOut", "toggle1to1", "rotateCCW", "rotateCW", "flipX", "flipY"],
                right: ["slideshow", "thumbs", "close"],
              },
            },
          });
        }
      },
    },
  ]);
}

/**
 * 回到顶部
 * @function initToTop
 * @param el 绑定的元素 e.g. ".toTop"
 * @param time 动画执行所需时间
 */
export function initToTop(el: string, time: number = 500) {
  if ($(el).length) {
    $(el).on("click", () => {
      $("html").css("scroll-behavior", "unset");
      $("html,body").animate({ scrollTop: 0 }, time);
      setTimeout(() => {
        $("html").css("scroll-behavior", "");
      }, time);
    });
  }
}

export function addDefaultTabelStyle() {
  $("table").addClass("table table-bordered table-striped");
  if ($(window).width()! <= 1024) {
    $("table").wrap('<div class="table-responsive"></div>');
  }
}
// 重载 1：hex 为 string
export function generateColors(hex: string, opts?: GenerateShadesStringOpts): { [key: string]: GenerateShadesReturnType };
// 重载 2：hex 为非空对象（至少包含一个属性）
export function generateColors<T extends { [key: string]: string }>(hex: NonEmptyRecord<T>, opts?: GenerateShadesStringOpts): { [key: string]: GenerateShadesReturnType };
// 重载 3：hex 为 GenerateShadesParamsType（必须包含 colors 属性），不允许传入 opts
export function generateColors(hex: GenerateShadesParamsType): { [key: string]: GenerateShadesReturnType };
export function generateColors(hex: GenerateShadesHexType | GenerateShadesParamsType, opts?: Partial<GenerateShadesParamsType>): { [key: string]: GenerateShadesReturnType } {
  // 类型守卫：判断 hex 是否为 GenerateShadesParamsType（即具有 colors 属性）
  const isShadesParamsType = (obj: unknown): obj is GenerateShadesParamsType & { colors: GenerateShadesHexType } => {
    return typeof obj === "object" && obj !== null && "colors" in obj;
  };
  // 使用 opts.count 默认值
  // let { count = 3, setName = "themeColor", setTo = false } = hex || opts || {};
  const { count = 3, setName = "themeColor", setTo = false } = isShadesParamsType(hex) ? hex : opts || {};
  // 将 hex 字符串转换为 HSL
  const hexToHsl = (hex: string) => {
    const r = parseInt(hex.substring(1, 3), 16) / 255;
    const g = parseInt(hex.substring(3, 5), 16) / 255;
    const b = parseInt(hex.substring(5, 7), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h: number, s: number;
    const l = (max + min) / 2;
    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) {
        h = (g - b) / d + (g < b ? 6 : 0);
      } else if (max === g) {
        h = (b - r) / d + 2;
      } else {
        h = (r - g) / d + 4;
      }
      h /= 6;
    }
    return { h: h * 360, s: s * 100, l: l * 100 };
  };

  // 将 HSL 转换为 hex 字符串
  const hslToHex = (h: number, s: number, l: number) => {
    s /= 100;
    l /= 100;
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;
    let r: number, g: number, b: number;
    if (h < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (h < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (h < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (h < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (h < 300) {
      r = x;
      g = 0;
      b = c;
    } else {
      r = c;
      g = 0;
      b = x;
    }
    r = Math.round((r + m) * 255);
    g = Math.round((g + m) * 255);
    b = Math.round((b + m) * 255);
    return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
  };

  // 生成明暗色调
  const generate = (h: number, s: number, l: number) => {
    const lighter: string[] = [];
    const darker: string[] = [];
    for (let i = 1; i <= count; i++) {
      lighter.push(hslToHex(h, s, Math.min(l + i * 10, 100)));
      darker.push(hslToHex(h, s, Math.max(l - i * 10, 0)));
    }
    return { lighter, darker };
  };

  const generateForHex = (hex: string) => {
    const { h, s, l } = hexToHsl(hex);
    return generate(h, s, l);
  };

  const generateForObject = (obj: { [key: string]: string }) => {
    const result: { [key: string]: GenerateShadesReturnType } = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        result[key] = generateForHex(obj[key]);
      }
    }
    if (setTo) {
      const setRootEl = (setTo instanceof HTMLElement ? setTo : "html body") as unknown as JQueryStatic;
      Object.keys(result).forEach((key) => {
        const { darker, lighter } = result[key];
        darker.forEach((color, idx) => {
          $(setRootEl).css(`--${key}-dark-${idx + 1}`, color);
        });
        lighter.forEach((color, idx) => {
          $(setRootEl).css(`--${key}-light-${idx + 1}`, color);
        });
      });
    }
    return result;
  };

  // 如果 hex 是 GenerateShadesParamsType（必须包含 colors 属性）
  if (isShadesParamsType(hex)) {
    const colors = hex.colors;
    if (typeof colors === "string") {
      return generateForObject({ [setName]: colors });
    } else {
      return generateForObject(colors);
    }
  }

  // 如果 hex 为 string，则直接生成
  if (typeof hex === "string") {
    return generateForObject({ [setName]: hex });
  }

  // 如果 hex 为对象（注意此处对象已经被限制为非空）
  return generateForObject(hex);
}
